import PT from 'prop-types'
import React from 'react'
import { WidgetAddAreaProps } from 'index.d'
import styled from 'styled-components'
import { LabelsPropType, WidgetMapPropType } from 'index.pt'
import WidgetAdd from './WidgetAdd'

export const WidgetAddAreaDiv = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 0.5rem;
  background-color: var(--navds-semantic-color-component-background-alternate);
`

const WidgetAddArea: React.FC<WidgetAddAreaProps> = ({
  availableWidgets, highContrast, myWidgets, onPlaceholderWidgetAdd
}: WidgetAddAreaProps): JSX.Element => (

  <WidgetAddAreaDiv>
    {availableWidgets.map((widgetTemplate, i) => (
      <WidgetAdd
        key={i}
        highContrast={highContrast}
        myWidgets={myWidgets}
        widgetTemplate={widgetTemplate}
        onPlaceholderWidgetAdd={onPlaceholderWidgetAdd}
      />
    ))}
  </WidgetAddAreaDiv>
)

WidgetAddArea.propTypes = {
  availableWidgets: PT.array.isRequired,
  labels: LabelsPropType.isRequired,
  myWidgets: WidgetMapPropType.isRequired,
  onPlaceholderWidgetAdd: PT.func.isRequired
}

export default WidgetAddArea
